import OneSignal from 'react-onesignal';
import { localStorageKey } from './constants/LocalStorageKey';


export default async function runOneSignal() {
  await OneSignal.init({ appId: '8c167f40-4cef-46e9-ad71-112e2ad9017d', allowLocalhostAsSecureOrigin: true});
  OneSignal.showSlidedownPrompt();
  OneSignal.getUserId().then((userId) => {
   sessionStorage.setItem(localStorageKey.USERID, userId);
  })
}